// pending instanced mesh setup

export function MeshParticle() {
    return <></>
}